import React, { useState } from "react";
import AdditionalPatientPay from "../../../pages/AdditionalPatientPay/AdditionalPatientPay";
import AdditionalPatientPaySteps from "../../../pages/AdditionalPatientPay/AdditionalPatientPaySteps";
import { useLocation, useNavigate } from "react-router-dom";
import AdditionalPatientPayScheduleForm from "../../../pages/AdditionalPatientPay/AdditionalPatientPayScheduleForm";
import AdditionalPatientPayStepScheduleForm from "../../../pages/AdditionalPatientPay/AdditionalPatientPayStepsForm";
import PriceEdgeSchedule from "../../../pages/PriceEdgeSchedule/PriceEdgeSchedule";
import { PRICE_SCHEDULE_MODES } from "../../utils/Constants";

const AdditonalPatientPayLookUp = ({
  params,
  intialSchedule = "",
  onSelect,
  hideModal,
  selectMode,
  lookupType,
  scheduleFlag,
  selectParamsData,
  readOnly,
  initialSelectedPatient,
  mode,
  disabledDropdown = false,
  onNavigate,
}) => {
  const scheduleKey = params[0].source;
  const intialScheduleName = intialSchedule[scheduleKey];
  const [schedule, setSchedule] = useState({
    apsAddtlPatPaySch: intialScheduleName,
  });
  const [scheduleDesc, setScheduleDesc] = useState("");
  const [flag, setFlag] = useState(false);
  const effectiveReadonly = intialSchedule["readOnly"];

  const renderAdditionalPatientPayOrReadOnly = () => {
    if (effectiveReadonly) {
      return (
        <AdditionalPatientPayScheduleForm
          hideModal={hideModal}
          selectMode={true}
          mode={mode}
          lookupType={lookupType}
          initialSelectedPatient={initialSelectedPatient}
        />
      );
    }

    return (
      <AdditionalPatientPay
        params={params}
        onSelect={setSchedule}
        setFalg={setFlag}
        hideModal={hideModal}
        selectMode={selectMode}
        lookupType={lookupType}
        selectParamsData={selectParamsData}
        setScheduleDesc={setScheduleDesc}
        disabledDropdown={disabledDropdown}
        onNavigate={onNavigate}
      />
    );
  };

  const renderAdditionalPatientPayStepsOrReadOnly = () => {
    if (effectiveReadonly) {
      return (
        <AdditionalPatientPayStepScheduleForm
          params={params}
          hideModal={hideModal}
          selectMode={true}
          mode={PRICE_SCHEDULE_MODES.READ_ONLY}
          lookupType={lookupType}
          initialSelectedPatient={initialSelectedPatient}
          schedule={schedule}
          scheduleDesc={scheduleDesc}
          selectParamsData={selectParamsData}
          intialSchedule={intialSchedule}
        />
      );
    }

    return (
      <AdditionalPatientPaySteps
        params={params}
        schedule={schedule}
        onSelect={onSelect}
        hideModal={hideModal}
        selectMode={selectMode}
        lookupType={lookupType}
        scheduleDesc={scheduleDesc}
        onNavigate={onNavigate}
      />
    );
  };

  if (!scheduleFlag) {
    return (
      <div>
        {!flag && renderAdditionalPatientPayOrReadOnly()}
        {flag && renderAdditionalPatientPayStepsOrReadOnly()}
      </div>
    );
  } else {
    return (
      <div>
        {!schedule.apsAddtlPatPaySch && renderAdditionalPatientPayOrReadOnly()}
        {schedule.apsAddtlPatPaySch &&
          renderAdditionalPatientPayStepsOrReadOnly()}
      </div>
    );
  }
};

export default AdditonalPatientPayLookUp;
